import { arrays } from './arrays';

export var strings = {
    capitalize,
    filenameHasBadChar,
    sanitizeFilename,
    join,
    normalize,
    pixelate,
    pointillate,
    inchify,
    possessify,
    random,
    wordsFromCamelCase,
    strictEncode,
    strictEncode,
    escape
}

export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function filenameHasBadChar(str) {
    return /[\x00-\x1f\x7f<>:"\\|?*%\/]/.test(str);
}

export function sanitizeFilename(str) {
    return str.replace(/[\x00-\x1f\x7f<>:"\\|?*%\/]/g, '_');
}

export function join(separator = ' ', ...strs) {
    return arrays.join(separator, strs);
}

export function normalize(str) {
    return str
        .replace(/\W/g, '')
        .toLowerCase()
}

export function pixelate(num) {
    return isNaN(num) ? '0' : Math.round(num * 10000) / 10000 + 'px';
}

export function pointillate(num) {
    return isNaN(num) ? '0' : Math.round(num * 10000) / 10000 + 'pt';
}

export function inchify(num) {
    return isNaN(num) ? '0' : Math.floor(num * 100000) / 100000 + 'in';
}

export function possessify(str) {
    return str + (str.substr(-1) === 's' ? "'" : "'s");
}

export function random(len = 8, chars = "ABCDEFGHIJKLMNOPQRSTUFWXYZ") {
    let str = '';
    for (let i = len; i > 0; --i) {
        str += chars[Math.floor(Math.random() * chars.length)];
    }
    return str;
}

const crcTable = [];
for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) {
        c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
        crcTable[n] = c;
    }
}
export function crc32(str) {
    let crc = 0 ^ -1;
    for (let i = 0; i < str.length; i++) {
        crc = (crc >>> 8) ^ crcTable[(crc ^ str.charCodeAt(i)) & 0xFF];
    }
    return ((crc ^ -1) >>> 0).toString(16).toUpperCase();
}

export function wordsFromCamelCase(str = '') {
    return str.split(/(?=[A-Z])/)
        .map(str => strings.capitalize(str))
        .join(' ');
}

export function strictEncode(str, strictCharsOnly = false) {
    if (!strictCharsOnly) str = encodeURIComponent(str);
    return str.replace(/[!'()* ]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
}

export function escape(str) {
    let el = document.createElement('div');
    el.innerText = str;
    return el.innerHTML;
}